import { render, staticRenderFns } from "./RealEstate.vue?vue&type=template&id=ea7e9aa8&"
import script from "./RealEstate.vue?vue&type=script&lang=js&"
export * from "./RealEstate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports